import { DivisionListResponse, DivisionProfileListResponse, IcdOfficeModel, RoleListModel, TeamListResponse, PermissionGrant } from "@herbjoy/apex-api-models";
import templateUrl from "./icd-corporation-dashboard-offices-details.component.html";
import "./icd-corporation-dashboard-offices-details.component.less";

export const IcdCorporationDashboardOfficesDetailsComponent = {
    require: {
        form: "^^?form"
    },
    bindings: {
        icdOffices: "<",
        divisions: "<",
        divisionProfiles: "<",
        teams: "<",
        globalOfficeRoles: "<",
        permissionGrants: "<"
    },
    templateUrl,

    controller: class IcdCorporationDashboardOffices {
        icdOffices: IcdOfficeModel[];
        divisions: DivisionListResponse[];
        divisionProfiles: DivisionProfileListResponse[];
        teams: TeamListResponse[];
        globalOfficeRoles: RoleListModel[];
        permissionGrants: PermissionGrant[];
        constructor() {
            'ngInject';
        }

        $onInit() {
        }

        $onChanges(changesObj) {
            if (changesObj.icdOffices && this.icdOffices) {
                this.icdOffices = this.icdOffices.map(p => this.hydrateIcdOfficeDetails(p))
            }
        }

        hydrateIcdOfficeDetails(office) {
            const officeDivisions = Object.values(office.OfficeDivisions.Divisions);
            office.Divisions = officeDivisions.map(d =>
                this.hydrateOfficeDivisions(d, this.divisions, this.divisionProfiles));

            const officeRolesTeams = office.OfficeRoles.filter(p => this.globalOfficeRoles
                .some(q => q.Id === p.RoleID));
            officeRolesTeams.forEach((offieRole) => this.hydrateOfficeRoles(offieRole, this.globalOfficeRoles));
            office.OfficeRolesTeams = officeRolesTeams;
            return office;
        }

        hydrateOfficeRoles(offieRole, globalOfficeRoles) {
            offieRole.Role = globalOfficeRoles.find(q => q.Id === offieRole.RoleID);
            offieRole.Teams = offieRole.AssignedPositions.map(p => this.mapTeam(p, this.teams));
        }

        mapTeam(position, teams) {
            position.Team = teams.find(p => p.TeamID === position.TeamID)
            return position;
        }

        hydrateOfficeDivisions(d, divisions, divisionProfiles) {
            const division = divisions.find(p => p.Id === d.DivisionID);
            const divisionProfile = divisionProfiles.find(p => p.DivisionProfileID === d.DivisionProfileID);
            const profileName = divisionProfile ? " (" + divisionProfile.Name + ")" : "(no profile)";

            return {
                ...division,
                DivisionAndProfileName: division.Name + " " + profileName
            }
        }
    }
};
